import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showMetadataQueryInfoProp)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "info",
          class: "p-mx-2",
          closable: true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.showMetadataQueryInfo')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Card, { class: "p-m-2" }, {
      header: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.fieldsMetadata')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withCtx(() => [
        (_ctx.dataset.meta && (_ctx.dataset.meta.ccolumns || _ctx.dataset.meta.dataset))
          ? (_openBlock(), _createBlock(_component_DataTable, {
              key: 0,
              class: "p-datatable-sm kn-table kn-table-small-input",
              autoLayout: true,
              value: _ctx.fieldsMetadata,
              responsiveLayout: "stack",
              breakpoint: "960px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "fieldAlias",
                  header: _ctx.$t('managers.datasetManagement.fieldAlias'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(data.fieldAlias), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "Type",
                  header: _ctx.$t('importExport.catalogFunction.column.type'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Dropdown, {
                      class: "kn-material-input",
                      style: _ctx.linkTabDescriptor.style.maxwidth,
                      modelValue: data.Type,
                      "onUpdate:modelValue": ($event: any) => (data.Type = $event),
                      options: _ctx.valueTypes,
                      optionDisabled: "disabled",
                      optionLabel: "value",
                      optionValue: "name",
                      onChange: _ctx.saveFieldsMetadata,
                      disabled: true
                    }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options", "onChange"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "fieldType",
                  header: _ctx.$t('managers.datasetManagement.fieldType'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Dropdown, {
                      class: "kn-material-input",
                      style: _ctx.linkTabDescriptor.style.maxwidth,
                      modelValue: data.fieldType,
                      "onUpdate:modelValue": ($event: any) => (data.fieldType = $event),
                      options: _ctx.fieldMetadataTypes,
                      optionLabel: "value",
                      optionValue: "value",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveFieldsMetadata('fieldType')))
                    }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "personal",
                  header: _ctx.$t('managers.datasetManagement.personal'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Checkbox, {
                      id: "personal",
                      modelValue: data.personal,
                      "onUpdate:modelValue": ($event: any) => (data.personal = $event),
                      binary: true,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveFieldsMetadata('personal')))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "decrypt",
                  header: _ctx.$t('managers.datasetManagement.decrypt'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Checkbox, {
                      id: "decrypt",
                      modelValue: data.decrypt,
                      "onUpdate:modelValue": ($event: any) => (data.decrypt = $event),
                      binary: true,
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveFieldsMetadata('decrypt')))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "subjectId",
                  header: _ctx.$t('managers.datasetManagement.subjectId'),
                  sortable: true
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Checkbox, {
                      id: "subjectId",
                      modelValue: data.subjectId,
                      "onUpdate:modelValue": ($event: any) => (data.subjectId = $event),
                      binary: true,
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveFieldsMetadata('subjectId')))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        (!_ctx.dataset.meta || _ctx.dataset.meta.length == 0)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode(_component_Message, {
                severity: "info",
                closable: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.metadataInfo')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}